module.exports = __webpack_public_path__ + "static/media/UserProfileLight.512b4b62.svg";